/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { normalizeTextarea } from '@/utils/sms-text';

App.ready(() => App.message_modal_counter.init());


App.message_modal_counter = {

  MAX_LENGTH_ASCII: 160,

  MAX_LENGTH_UTF16: 70,

  init() {
    return $(document)
      .off('keyup change', '.js-form-message-body', App.message_modal_counter.update)
      .on('keyup change', '.js-form-message-body', App.message_modal_counter.update);
  },


  max_chars(text) {
    const max = App.utils.is_ascii(text) ?
            App.message_modal_counter.MAX_LENGTH_ASCII
          :
            App.message_modal_counter.MAX_LENGTH_UTF16;

    const $textarea = $(".js-form-message-body");
    return max;
  },


  toggle_special_chars_notice(text) {
    if (App.utils.is_ascii(text)) {
      return $(".js-special-chars-notice").addClass("hidden");
    } else {
      return $(".js-special-chars-notice").removeClass("hidden");
    }
  },


  get_length(el) {
    if (el.hasAttribute("data-preview")) {
      return $(el).attr("data-formatted-length")*1;
    } else {
      return el.value.length;
    }
  },


  update() {
    // Text set by code (From name, coupon, reply fills) skips the composer's
    // input handler; clean it here so it's counted against the right limit.
    // The change event reruns this with the clean text.
    if (normalizeTextarea(this)) {
      $(this).trigger('change');
      return;
    }

    const max_length = App.message_modal_counter.max_chars(this.value);

    App.message_modal_counter.toggle_special_chars_notice(this.value);

    let length = App.message_modal_counter.get_length(this);

    // console.log "counter max_length: ", max_length
    // console.log "counter length: ", length
    if (length > max_length) {
      const old_val = this.value;
      const new_val = old_val.substring(0, old_val.length - (length - max_length));
      $(this).val(new_val);
      length = max_length;
      // Force an update of the preview
      $(".js-form-message-body").change();
    }

    const counter_txt = length === (max_length - 1) ? "Character" : "Characters";

    $('.js-characters-text').text(counter_txt + ' Left');
    $('.js-characters-remaining').text(`${max_length - length} / ${max_length}`);
    $('.char-counter').toggleClass('char-counter-warning', length > (max_length - 11));

    if (length === max_length) {
      if ($('.js-char-counter-info').length === 0) {
        return $('.char-counter').after("<div class='char-counter-info js-char-counter-info'>You cannot send a longer message.</div>");
      }
    } else {
      return $('.js-char-counter-info').remove();
    }
  }
};
